














































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import DateField from "@/components/misc/DateField.vue";
import TimeField from "@/components/misc/TimeField.vue";
import { ArrivalOrganizationType } from "@/shared/models/arrivalOrganizationType";
import { GlobalFilterProperty } from "@/store/modules/globalFilters";
import {
  EVisitorFacilityService,
  eVisitorFacilityServiceFactory,
} from "../check-in/eVisitorFacilityService";
import _ from "lodash";
import {
  EVisitorIntegrationEnum,
  EVisitorIntegrationNameEnum,
} from "@/shared/models/enums.type";
import { EVisitorIntegrationModel } from "@/shared/models/eVisitor";

@Component({ components: { RightDrawer, DateField, TimeField } })
export default class MultipleGuestsEditForm extends Vue {
  fkey = 0;

  @Prop() open?: boolean;
  @Prop({ default: () => [] }) guestIds?: number[];
  @Prop() type?: "checkIn" | "checkOut";
  @Prop({ default: () => false }) anySelectedIsCheckedIn?: boolean;

  checkInDate = null as string | null;
  checkInTime = null as string | null;
  checkOutDate = null as string | null;
  checkOutTime = null as string | null;
  propertyId = null as number | null;
  eVisitorFacilityId = null as number | null;
  eVisitorArrivalOrganizationTypeId = null as number | null;

  get initial() {
    return {
      checkInDate: "",
      checkInTime: "",
      checkOutDate: "",
      checkOutTime: "",
      propertyId: null,
      eVisitorFacilityId: null,
      eVisitorArrivalOrganizationTypeId: null,
    };
  }

  get current() {
    return {
      checkInDate: this.checkInDate,
      checkInTime: this.checkInTime,
      checkOutDate: this.checkOutDate,
      checkOutTime: this.checkOutTime,
      propertyId: this.propertyId,
      eVisitorFacilityId: this.eVisitorFacilityId,
      eVisitorArrivalOrganizationTypeId: this.eVisitorArrivalOrganizationTypeId,
    };
  }

  isFormValid = false;
  loading = false;

  @Getter("appParams/tenantEVisitorIntegration")
  eVisitorIntegration?: EVisitorIntegrationModel;

  get eVisitorIntegrationId() {
    return this.eVisitorIntegration?.id ?? EVisitorIntegrationEnum.None;
  }
  get eVisitorIntegrationName() {
    return this.eVisitorIntegration?.name ?? EVisitorIntegrationNameEnum.None;
  }

  get isHReVisitor() {
    return this.eVisitorIntegrationId === EVisitorIntegrationEnum.HR;
  }

  @Getter("codebooks/arrivalOrganizationTypes")
  arrivalOrganizationTypes?: ArrivalOrganizationType[];

  @Getter("globalFilters/properties")
  allUserProperties?: GlobalFilterProperty[];

  get properties() {
    if (!this.allUserProperties) return [] as GlobalFilterProperty[];
    const tempProperties = [...(this.allUserProperties ?? [])];
    return _.sortBy(
      tempProperties.filter((x) => x.status !== false), 
      (x) => x.name
    );
  }
  
  eVisitorFacilityService: EVisitorFacilityService | null = null;

  mounted() {
    this.eVisitorFacilityService = eVisitorFacilityServiceFactory(this);
  }

  eVisitorFacilities(eVisitorFacilityPropertyId: number) {
    if (!eVisitorFacilityPropertyId) return [];

    if (this.eVisitorFacilityService) {
      if (
        !this.eVisitorFacilityService.groups.some(
          (x) => x.propertyId === eVisitorFacilityPropertyId
        )
      ) {
        this.eVisitorFacilityService.loadGroup(eVisitorFacilityPropertyId);
      }

      const group = this.eVisitorFacilityService.findGroup(
        eVisitorFacilityPropertyId
      )?.facilities;

      return _.sortBy(group, (g) =>
        g.accountName ? g.accountName : g.facility
      );
    }

    return [];
  }

  get rules() {
    const required = (value: any) => !!value || this.$t("Validation.Required");
    return {
      required,
      requiredIfAllSelectedAreNotCheckedIn: (value: any) => {
        return this.anySelectedIsCheckedIn || required(value);
      },
      dateTimesOrder: () => {
        // Validation.SetCheckedInCustomers.CheckInDateTimeMustBeLessThanCheckOut
        const from =
          this.checkInDate?.substr(0, 10) + (this.checkInTime ?? "00:00");
        const to =
          this.checkOutDate?.substr(0, 10) + (this.checkOutTime ?? "00:00");

        return from > to
          ? this.$t(
              "Validation.SetCheckedInCustomers.CheckInDateTimeMustBeLessThanCheckOut"
            ).toString()
          : true;
      },
    };
  }

  async save() {
    await this.submitSave();
    await Vue.axios.post("/reservations/ReservationUpdateForMultipleGuestIds", {
      guestIds: this.guestIds,
    });

    this.$emit("refresh");
  }

  async checkIn() {
    this.loading = true;

    try {
      await this.submitSave();
    } catch {
      this.loading = false;
      return;
    }

    await this.axios
      .post(`reservations/CheckInMultipleGuestsToEVisitor`, {
        guestIds: this.guestIds,
      })
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("EVisitor.CheckInSuccess"),
          timeout: 5000,
        });

        this.close();
      })
      .finally(() => {
        this.loading = false;
      });

    await Vue.axios.post("/reservations/ReservationUpdateForMultipleGuestIds", {
      guestIds: this.guestIds,
    });

    this.$emit("refresh");
  }

  async updateEVisitorCheckIn() {
    await this.submitSave();

    this.$emit("checkInSelected");

    // the checkInSelected is handled outside
    // it should close the form at the end so loading (setting false) doesn't matter...
    this.loading = true;
  }

  async checkOut() {
    this.loading = true;

    try {
      await this.submitSave();
    } catch {
      this.loading = false;
      return;
    }

    await this.axios
      .post(`reservations/CheckOutMultipleGuestsToEVisitor`, {
        guestIds: this.guestIds,
      })
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("EVisitor.CheckOutSuccess"),
          timeout: 5000,
        });

        this.close();
      })
      .finally(() => {
        this.loading = false;
      });

    await Vue.axios.post("/reservations/ReservationUpdateForMultipleGuestIds", {
      guestIds: this.guestIds,
    });

    this.$emit("refresh");
  }

  async submitSave() {
    const payload = {
      guestIds: this.guestIds,
      checkInDate: this.checkInDate,
      checkInTime: this.checkInTime,
      checkOutDate: this.checkOutDate,
      checkOutTime: this.checkOutTime,
      eVisitorFacilityId: this.eVisitorFacilityId,
      eVisitorArrivalOrganizationTypeId: this.eVisitorArrivalOrganizationTypeId,
      isForCheckOut: this.type === "checkOut",
    };

    this.loading = true;
    await Vue.axios
      .post("/reservations/EVisitorUpdateMultipleGuests", payload)
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("EVisitor.SaveSuccess", {
            eVisitorServiceName: this.eVisitorIntegrationName,
          }),
          timeout: 5000,
        });
      })
      .finally(() => {
        this.loading = false;
      });
    this.$emit("saved");
  }

  @Watch("open")
  openWatch(fresh: boolean, old: boolean) {
    if (fresh && !old) {
      this.fkey++;
      this.loading = false;

      // reset fields values
      this.checkInDate = null;
      this.checkInTime = null;
      this.checkOutDate = null;
      this.checkOutTime = null;
      this.eVisitorFacilityId = null;
      this.propertyId = null;
      this.eVisitorArrivalOrganizationTypeId = null;
    }
  }

  close() {
    this.$emit("update:open", false);
  }
}
